module.exports = __webpack_public_path__ + "static/media/Elpro-elite-Logo.3978ec6e.svg";